import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { CookieManagerService } from './cookie-manager.service';
import { CookieNames ,Time,TimeFormatter} from '../../core-modules/constant';
import { TimeService } from './time.service';

@Injectable()
export class BasicTimerService {


  constructor(private cookieManagerService: CookieManagerService) { }

  /**
   * Timer reseset()
   */
  examReloadReset(){
    this.cookieManagerService.setCookie(CookieNames.timestore, '0', false, 1);
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/basic-timer.service.ts